import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import {t} from "i18next";

const AnnouncementSlice = createSlice({
    name: 'announcement',
    initialState: {
        getListAnnouncements: [],
        notifyTypes: [],
        employeesData: [],
    },
    reducers: {},
    extraReducers: {
        'announcements/getListAnnouncements/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getListAnnouncements = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'announcements/announcementTypes/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.notifyTypes = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'announcements/getEmployeesPageable/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.employeesData = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
    },
});

export const {} = AnnouncementSlice.actions;

export default AnnouncementSlice.reducer;
